import LockResetIcon from '@mui/icons-material/LockReset'
import { Box, Button, Paper, Stack, Typography } from '@mui/material'

import { useAuth } from '../auth/useAuth'
import ChangePasswordForm from '../components/ChangePasswordForm'

/**
 * Shown instead of the app when must_change_password is set.
 *
 * Whoever created the account chose the password they signed in with, so it is
 * a handover credential, not theirs. Nothing else is reachable until it is
 * replaced -- a dismissible prompt would leave that credential valid forever
 * and make the flag decorative.
 */
export default function ChangePasswordPage() {
  const { signOut, refresh } = useAuth()

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'grid',
        placeItems: 'center',
        p: 2,
        bgcolor: 'background.default',
      }}
    >
      <Paper sx={{ p: 4, width: '100%', maxWidth: 440 }}>
        <Stack spacing={3}>
          <Stack direction="row" spacing={1.5} alignItems="center">
            <LockResetIcon color="primary" />
            <Typography variant="h6" component="h1">
              Choose your own password
            </Typography>
          </Stack>

          <Typography color="text.secondary" variant="body2">
            You signed in with a password someone else set for you. Pick one only you know before
            carrying on.
          </Typography>

          <ChangePasswordForm
            submitLabel="Set Password and Continue"
            busyLabel="Saving…"
            // The change revokes every session, this one included, so there is
            // nothing to resume: re-reading the session sends them back to sign
            // in with the password they just chose.
            onDone={refresh}
          >
            <Button onClick={() => void signOut()} size="small">
              Sign out instead
            </Button>
          </ChangePasswordForm>
        </Stack>
      </Paper>
    </Box>
  )
}
